module.exports = __webpack_public_path__ + "static/media/asp-logo.5da55eb1.jpeg";